var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 36",
    width: 37,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.594 29.35H5.192a.6.6 0 1 0 0 1.203h5.402a.6.6 0 1 0 0-1.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.997 17.323H35.2c.994.001 1.8.808 1.8 1.804V34.16c-.001.996-.807 1.803-1.8 1.804H2.19c-.663-.001-1.2-.54-1.2-1.203V4.695a1.2 1.2 0 0 1 1.089-1.191l.004-.002L21.184.02a1.2 1.2 0 0 1 .982.262c.273.228.43.566.43.922v2.3h.6c.994.001 1.8.808 1.8 1.804v12.027zm-3.6-13.83v-2.3L8.84 3.493h12.556zM2.2 4.695h21.006a.6.6 0 0 1 .6.601v12.027h-3.38a7.79 7.79 0 0 0-1.158-7.044l-.005-.015c-.03-.048-.054-.077-.083-.103a7.77 7.77 0 0 0-12.355.001.56.56 0 0 0-.077.086l-.01.03c-1.693 2.28-2.012 5.304-.833 7.89a7.78 7.78 0 0 0 6.499 4.532v4.244H5.19a.6.6 0 1 0 0 1.203h7.202v6.013a1.79 1.79 0 0 0 .111.602H2.2V4.695zM17.178 15.52a14.01 14.01 0 0 1-.181 1.804h2.14a6.67 6.67 0 0 0 .425-1.804h-2.385zm-.001-1.203a13.93 13.93 0 0 0-.285-2.341c.565-.165 1.114-.378 1.64-.64.58.895.933 1.918 1.03 2.98h-2.386zm-6.6 4.43c.45 1.338 1.108 2.277 1.82 2.625v-2.828a13.08 13.08 0 0 0-1.82.203zm1.82-1.405a14.24 14.24 0 0 0-2.131.242 12.96 12.96 0 0 1-.252-2.063h2.383v1.82zm-2.137-5.084a12.69 12.69 0 0 0-.251 2.061h2.386v-1.82c-.716-.026-1.43-.107-2.134-.24zm2.137-3.792v2.83a13.17 13.17 0 0 1-1.817-.204c.456-1.344 1.127-2.273 1.817-2.626zm3.334 3.792c-.704.133-1.418.214-2.134.24v1.82h2.386a12.62 12.62 0 0 0-.251-2.061zm-2.134-.962v-2.83c.7.352 1.36 1.282 1.817 2.626a13.17 13.17 0 0 1-1.817.204zm2.1-2.404c.377.6.675 1.247.887 1.923.407-.12.805-.27 1.192-.444a6.63 6.63 0 0 0-2.078-1.479zm-6.29 1.923a9.14 9.14 0 0 1-1.192-.444c.6-.623 1.296-1.126 2.078-1.48a8.27 8.27 0 0 0-.887 1.923zm-.3 1.163a10.06 10.06 0 0 1-1.642-.639 6.57 6.57 0 0 0-1.029 2.98h2.386c.028-.787.124-1.57.285-2.34zM8.81 15.52c.03.788.126 1.572.285 2.344a9.89 9.89 0 0 0-1.653.639 6.56 6.56 0 0 1-1.023-2.983h2.4zm1.477 5.43c-.378-.6-.677-1.246-.89-1.922a9.1 9.1 0 0 0-1.196.444 6.54 6.54 0 0 0 2.085 1.477zm3.907-3.625c-.096.002-.192.012-.287.03l-.183-.006-.13-.004V15.52h2.385c-.024.606-.093 1.21-.205 1.804h-1.58zM35.2 34.762a.6.6 0 0 0 .6-.602V19.127a.6.6 0 0 0-.6-.602H14.194a.6.6 0 0 0-.6.602V34.16a.6.6 0 0 0 .6.602H35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 19.73H15.395a.6.6 0 0 0 0 1.203H34a.6.6 0 0 0 0-1.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.995 22.134h6.002c.662.001 1.2.54 1.2 1.203v7.216c-.001.664-.538 1.202-1.2 1.203h-6.002c-.662-.001-1.2-.54-1.2-1.203v-7.216c.001-.664.538-1.202 1.2-1.203zm6.003 6.297v-5.094h-6.002v5.094c.383-.27.807-.48 1.255-.62a2.11 2.11 0 0 1 .361-2.752c.793-.697 1.978-.697 2.77 0a2.11 2.11 0 0 1 .361 2.752 4.45 4.45 0 0 1 1.255.619zm-3.902-1.787a.9.9 0 1 1 1.801 0 .9.9 0 1 1-1.801 0zm.9 2.105c-1.626 0-3 .826-3 1.804h6.002c0-.978-1.375-1.804-3-1.804z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 22.134h-7.802a.6.6 0 1 0 0 1.203H33.4a.6.6 0 1 0 0-1.203z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 2.405
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: 2.405
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 4.81
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: 4.81
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 7.215
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: 7.215
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M26.196 24.54h-.6a.6.6 0 1 0 0 1.203h.6a.6.6 0 1 0 0-1.203z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M33.4 24.54h-4.8a.6.6 0 1 0 0 1.203h4.8a.6.6 0 1 0 0-1.203z"
  }))));
}

export default __webpack_public_path__ + "media/b8b07c7c.svg";
export { SvgPassport as ReactComponent };